import { BaseSignalRConnection } from './base-signalr-connection';
import { createClickStreamData } from './click-stream-data-factory';

export class ClickStream extends BaseSignalRConnection {
  constructor() {
    super(process.env.REACT_APP_SIGNALR_URL || '');
    this.init();
  }

  // This method is specific to ClickStream and handles click events
  handleEvent(e: MouseEvent): void {
    const csEvent = createClickStreamData(e);

    if (this.isConnected) {
      this._connection.send('SendJsonMessage', JSON.stringify(csEvent));
    }
  }

  // Overriding the startConnection to add custom behavior
  public async startConnection(): Promise<void> {
    await super.startConnection();

    // Additional ClickStream-specific logic after establishing the connection
    if (this.isConnected) {
      console.log('ClickStream connection established');
      window.addEventListener('click', (e: MouseEvent) => this.handleEvent(e));
    }
  }
  private async init() {
    // if (process.env.NODE_ENV === 'development') {
    //   return;
    // }
    try {
      await this.connection.start();
      this._isConnected = true;
      window.addEventListener('click', (e: MouseEvent) => this.handleEvent(e));
    } catch (error) {
      console.error('Connection failed', error);
      this._isConnected = false;
    }
  }
}
